import Layout from "@xtribe/shared/components/lib/Layout/Layout";
import SignInForm from "@xtribe/shared/components/Auth/SignInForm";
import NextHead from "@xtribe/shared/components/lib/Head/NextHead";
import { GetServerSideProps } from "next";
import { getRequestSlug } from "@xtribe/shared/lib/host";
import { getPublicTeamData } from "./api/v0/teams/public";
import { Team } from "@prisma/client";
import { serializeQuery } from "@xtribe/shared/lib/text-transformations";

export interface AuthPageProps {
  team: Team;
  queryString: string | null;
}

const SignIn: React.FC<AuthPageProps> = ({ team, queryString }) => {
  return (
    <div className="theme-admin">
      <NextHead
        title={`Jetzt Anmelden — ${team?.name ?? "xTribe"}`}
        description={`Melde dich jetzt bei ${team?.name ?? "xTribe"} an.`}
      />
      <Layout>
        <div
          className={`px-2 md:px-4 min-h-screen flex py-8 md:py-16 items-center`}
        >
          <SignInForm team={team} queryString={queryString} />
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  let requestHost;
  const host = ctx.req.headers.host;
  if (
    process.env.NEXT_PUBLIC_APP_URL!?.includes(host ?? "") ||
    process.env.NEXT_PUBLIC_AUTH_URL!?.includes(host ?? "")
  ) {
    requestHost = ctx.query.request_host;
  } else {
    requestHost = host;
  }
  let slug;
  let customDomain;
  if (
    requestHost?.includes(process.env.NEXT_PUBLIC_APP_HOST!) ||
    requestHost?.includes("ghoststudio.io")
  ) {
    slug = getRequestSlug(requestHost.toString());
  } else {
    customDomain = requestHost?.toString();
  }
  let team = null;
  if (slug || customDomain) {
    team = await getPublicTeamData({ slug, customDomain, isSignup: true });
  }
  const queryString = serializeQuery(ctx.query);
  return { props: { team, queryString } };
};

export default SignIn;
